import * as _ from 'lodash';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { Formatter } from 'slickgrid';

export interface TimeFormatterOptions {
  format?: string;
}

export function time<T>(opts: TimeFormatterOptions): Formatter<T> {
  const fmt = opts.format || 'HH:mm';

  return function timeFormatter(row, cell, value, columnDef, data) {
    if (_.isString(value)) {
      value = parseISO(value);
    }
    return value ? format(value, fmt) : '';
  };
}
